import { HpError as i } from "@hprofits/shared/errors";
import "@orpc/contract";
const d = "Connection problem. Check your connection and try again.", u = "Request was canceled.", p = "Invalid request payload", l = "Server response does not match expected schema";
class c extends i {
  constructor(s, e, r, o) {
    super(r, o), this.method = s, this.url = e;
  }
}
class A extends c {
  constructor(s, e, r, o, n) {
    super(s, e, o, n), this.status = r;
  }
}
class R extends A {
  errorCode;
  errorId;
  timestamp;
  data;
  constructor(s, e, r, o, n, a, E) {
    super(s, e, r, n, E), this.errorCode = o, this.errorId = a.errorId, this.timestamp = a.timestamp, this.data = a;
  }
}
class S extends c {
  constructor(s, e, r) {
    super(s, e, d, r);
  }
}
class _ extends c {
  constructor(s, e, r) {
    super(s, e, u, r);
  }
}
class x extends c {
  constructor(s, e, r) {
    super(s, e, p, { cause: r }), this.validationError = r;
  }
}
class C extends c {
  constructor(s, e, r) {
    super(s, e, l, { cause: r }), this.validationError = r;
  }
}
export {
  c as ApiClientError,
  R as ApiError,
  A as HttpError,
  S as NetworkError,
  _ as RequestCancelledError,
  x as RequestPayloadValidationError,
  C as ResponsePayloadValidationError
};
//# sourceMappingURL=errors.js.map
